import { Component, inject, input, linkedSignal, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-person-selection',
    imports: [ReactiveFormsModule, FormsModule],
    templateUrl: './person-selection.component.html',
})
export class PersonSelectionComponent {
    selectedPersonsEmit = output<number>();
    min = input<number>();
    selectedPersons = linkedSignal(() => this.min() || 0);
    label = input.required<string>();
    price = input.required<number>();
    disabled = input<boolean>();
    private translationService = inject(TranslateService);
    private toastService = inject(ToastrService);

    increment() {
        if (this.disabled()) {
            this.translationService
                .get('booking.bookingForm.maxPersonAmountReached')
                .subscribe((res) => {
                    this.toastService.error(res);
                });
            return;
        }
        this.selectedPersons.set(this.selectedPersons() + 1);
        this.selectedPersonsEmit.emit(this.selectedPersons());
    }

    decrement() {
        if (this.selectedPersons() > (this.min() || 0)) {
            this.selectedPersons.set(this.selectedPersons() - 1);
            this.selectedPersonsEmit.emit(this.selectedPersons());
        } else {
            this.translationService
                .get('booking.bookingForm.minPersonAmountReached')
                .subscribe((res) => {
                    this.toastService.error(res);
                });
        }
    }
}
